import createIcon from '../../createIcon';

/**
 * @component @name DesktopWindows
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgM0g0QzIuOSAzIDIgMy45IDIgNVYxNUMyIDE2LjEgMi45IDE3IDQgMTdIMTBWMTlIOFYyMUgxNlYxOUgxNFYxN0gyMEMyMS4xIDE3IDIyIDE2LjEgMjIgMTVWNUMyMiAzLjkgMjEuMSAzIDIwIDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DesktopWindows = createIcon('DesktopWindows', [
  [
    'path',
    {
      d: 'M20 3H4C2.9 3 2 3.9 2 5V15C2 16.1 2.9 17 4 17H10V19H8V21H16V19H14V17H20C21.1 17 22 16.1 22 15V5C22 3.9 21.1 3 20 3Z',
      key: '197ivh',
    },
  ],
]);

export default DesktopWindows;
